import type { ReactNode } from 'react'
import { cn } from 'cn'

export function LiquidIcon({ children, className, tone = 'green' }: { children: ReactNode; className?: string; tone?: 'green' | 'violet' | 'silver' }) {
  return <span className={cn('liquid-icon', `liquid-icon--${tone}`, className)} aria-hidden="true"><span>{children}</span></span>
}
